
import {  Button, Card, CardActions, CardContent, CardHeader, Collapse, List, ListItem, ListItemIcon, ListItemText, Theme, Typography, useTheme } from "@mui/material";
import { ExpandMore, Square } from "@mui/icons-material";
import { isMobile, isTablet } from "react-device-detect";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { getObjectTypeName } from "../../common/utilities/GetObjectTypeName";
import { useMemo, useState } from "react";
import { AlarmSchemeTierType, TierActionItem, TierActions } from "./AlarmSchemeTierUtils";
import { useTranslation } from "react-i18next";
import ActionMenu from "../action-menu/ActionMenu";
import React from "react";
import { SxProps } from "@mui/system";

export type AlarmSchemeTierCardProps = {
    item: AlarmSchemeTierType,
    allowEdit?: boolean,
    onAction?: (action: TierActions, item: AlarmSchemeTierType) => void,
    dense?: boolean,
    sx?: SxProps<Theme>
};

export function AlarmSchemeTierCard({
    item,
    allowEdit,
    onAction,
    dense,
    sx
}: AlarmSchemeTierCardProps) {

    const [expanded, setExpanded] = useState(false);

    const isPhone = isMobile && !isTablet;
    const theme = useTheme();
    const { t }= useTranslation();


    const actionItems: TierActionItem[] = useMemo(() => {

        let actions: TierActionItem[] = [{

            label: t('actions.editTier'),
            action: TierActions.Edit,
            order: 0,
            onClick: () => {
                onAction && onAction(TierActions.Edit, item);
            },
        },
        {

            label: t('actions.deleteTier'),
            action: TierActions.Delete,
            order: 0,
            onClick: () => {
                onAction && onAction(TierActions.Delete, item);
            },
        }];
        
        
        return actions;

    }, [
        item,
        t,
        onAction
    ]);

    
    function toggleExpanded() {
        setExpanded(!expanded);
    }

    return (
        <Card variant="outlined" 
            sx={{
            
                backgroundColor: "custom.background.cardContainer",
                marginLeft: isPhone || dense ? 1 : 6,
                marginRight: 1,
                padding: 1,
                marginBottom: 1,
                ...sx
            }}>
            <CardHeader
                sx={{
                    padding: 1,
                    color: theme.palette.grey[600]
                }}
                title={item.name}
                //avatar={getAvatar()}
                //subheader={getSubheader()}
                //subheader={getTitle()}
                subheader={item.description}
                action={allowEdit ? <ActionMenu actionItems={actionItems} /> : undefined}
                slotProps={{
                    title: {
                        sx: {
                            fontSize: '1rem',
                        },
                    },

                    subheader: {
                        sx: {
                            fontSize: '.9rem'
                        }
                    }
                }}>
            </CardHeader>
            <CardActions sx={{ paddingTop: 0, paddingBottom: 0 }}>
                <Button
                    size="small"
                    sx={{
                        //color: "text.primary"
                        color: theme.palette.grey[600]
                    }}
                    variant="text"
                    onClick={() => toggleExpanded()}
                    style={{ marginLeft: "auto" }}
                    endIcon={<ExpandMore sx={{
                        transform: !expanded ? "rotate(0deg)" : "rotate(180deg)",
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shortest,
                        })
                    }} />}
                >
                    {item.useScheduledNotifications ? 
                        `${t('setpointAdmin.scheduledNotifications')} [${item.scheduledNotifications.length}]` :
                        `${getObjectTypeName(eLynxObjectTypeEnum.NotificationList, true)} [${item.notifications.length}]`}
                </Button> 
            </CardActions>
            <Collapse in={expanded} timeout="auto">

                <CardContent sx={{
                    padding: (theme) => `0 ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} !important`,
                }}>

                    <List sx={{
                        paddingTop: 0,
                        overflowX: "hidden",
                        overflowY: "auto",
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '1 1 auto'
                    }}>


                        {item.useScheduledNotifications ?
                        
                            item.scheduledNotifications.sort((a, b) => (a.scheduleName ?? '').localeCompare(b.scheduleName ?? ''))?.map((o, index) =>
                                <React.Fragment key={`sch:${index}`}>
                                    <Typography sx={{
                                        fontSize: '.9rem',
                                        color: theme.palette.grey[600]
                                    }}>
                                        {o.scheduleName}
                                    </Typography>

                                    <List sx={{
                                        paddingTop: 0,
                                        overflowX: "hidden",
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: '1 1 auto'        
                                    }}>

                                        {o.notifications.sort((a, b) => (a.notificationListName ?? '').localeCompare(b.notificationListName ?? ''))?.map((o, index) =>

                                            <ListItem key={`nl:${o.notificationListID}`} 
                                                disablePadding >
                                                <ListItemIcon sx={{fontSize: ".6rem", minWidth: 'auto', marginRight: theme.spacing(2)}}>
                                                    <Square fontSize="inherit"/>
                                                </ListItemIcon>
                                                <ListItemText primary={o.notificationListName} 
                                                    slotProps={{
                                                        primary: {
                                                            sx: {
                                                                fontSize: '.9rem',
                                                                color: theme.palette.grey[600]
                                                            }
                                                        }
                                                    }} />
                                            
                                            </ListItem>  
                                        )}                                      
                                    </List>


                                </React.Fragment>

                            ) :
                            item.notifications.sort((a, b) => (a.notificationListName ?? '').localeCompare(b.notificationListName ?? ''))?.map((o, index) =>

                            <ListItem key={o.notificationListID} 
                                disablePadding >
                                <ListItemIcon sx={{fontSize: ".6rem", minWidth: 'auto', marginRight: theme.spacing(2)}}>
                                    <Square fontSize="inherit"/>
                                </ListItemIcon>
                                <ListItemText primary={o.notificationListName} 
                                    slotProps={{
                                        primary: {
                                            sx: {
                                                fontSize: '.9rem'
                                            }
                                        }
                                    }} />
                            
                            </ListItem>
                        
                        
                        )}

                    </List>
               </CardContent>
            </Collapse>
        </Card>
    );
}





// <Box sx={{
//     backgroundColor: "custom.background.cardContainer",
//     marginLeft: isPhone || dense ? 1 : 6,
//     marginRight: 1,
//     padding: 1,
//     marginBottom: 1,
//     ...sx
// }}>

//     <Typography variant='subtitle1'
//         sx={{
//             color: theme.palette.grey[600]
//         }}>
//         {item.name}
//     </Typography>

//     <Typography variant="body2"
//         sx={{
//             color: theme.palette.grey[600]
//         }}>
//         {item.description}
//     </Typography>


//     {item.notifications.length > 0 && 
//         <>
//     <Typography variant="subtitle2" color='textSecondary' fontWeight='600' marginTop={1}>
//         {getObjectTypeName(eLynxObjectTypeEnum.NotificationList, true)}
//     </Typography>

//     <List sx={{
//         paddingTop: 0,
//         overflowX: "hidden",
//         overflowY: "auto",
//         display: 'flex',
//         flexDirection: 'column',
//         flex: '1 1 auto'
//     }}>
//         {item.notifications.sort((a, b) => (a.notificationListName ?? '').localeCompare(b.notificationListName ?? ''))?.map((o, index) =>

//             <ListItem key={index} 
//                 disablePadding >
//                 <ListItemIcon sx={{fontSize: ".6rem", minWidth: 'auto', marginRight: theme.spacing(2)}}>
//                     <Square fontSize="inherit"/>
//                 </ListItemIcon>
//                 <ListItemText primary={o.notificationListName} primaryTypographyProps={{
//                     fontSize: '.9rem'
//                 }} />
            
//             </ListItem>
//         )}
//     </List>
//     </>            
//     }
// </Box>    
